import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Helmet } from "react-helmet";
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import Icon from 'antd/lib/icon';
import './Chat.css';

import { ItemPicker, Modal, ComboBox, TagView, ChatTextBox, LoadingState, EmptyState } from '.././components/Common';
import { EField } from './Home';

const Trojan = window.Trojan;
const Croppie = window.Croppie;
const $ = window.$;
const jQuery = window.jQuery;
const EventSource = window.EventSource;

export default class Chats extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filters: ["All", "Chats", "Groups", "Teams", "Parents", "Emails"],
            activeFilter: "All",
            isCreateChat: false,
            chat: null,
            chats: [],
            rawChats: [],
            emails: [],
            activeChatIndex: 0,
            isLoading: true
        }

        this.setFilters = this.setFilters.bind(this)
        this.onChatSelect = this.onChatSelect.bind(this)
        this.onUserSelect = this.onUserSelect.bind(this)
        this.setCreatingChatView = this.setCreatingChatView.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
        this.initSystem();
        this.getEmails();
        FakeData.mountState("chatApp", true)
        FakeData.shared("chatApp", this)
        document.getElementById("root").style.overflowY = "hidden"
    }

    componentWillUnmount() {
        this._isMounted = false;
        FakeData.mountState("chatApp", false)
        FakeData.shared("chatApp", null)
        document.getElementById("root").style.overflowY = "auto"
        if(this.system){
            this.system.close()  
        }
    }

    setFilters(filter) {
        const _that = this
        this.setState({
            activeFilter: filter
        });
    }

    getChats() {
        const _that = this
        const dataTo = {
            user: _that.props.user?_that.props.user:FakeData.getData("yoo"),
            teams: []
        }

        if (!this._isMounted) {
            return;
        }

        FakeData.post("/getChats.php?auth0", dataTo, {
            success: ((res) => {
                //console.log(res)
                if (!_that._isMounted) {
                    return;
                }
                _that.setState({
                    rawChats: res,
                    isLoading: false
                });

                setTimeout(() => {
                    _that.getChats()
                }, 1000)
            }),
            error: ((err) => {
                //console.log(err)
            })
        })
    }

    initSystem = () => {
        if (EventSource) {
            const _that = this;
            const userType = _that.props.user?_that.props.user.type:"F";
            const userId = _that.props.user?_that.props.user.id:FakeData.getData("yoo").id;
            this.system = new EventSource(FakeData.fetchURL+ '/getChats.php?auth0&isStream&userId=' + userId+ '&userType='+userType);
            
            if (this.system !== null) {
                //this.system.addEventListener()
                this.system.onmessage = function (e) {
                    if (_that._isMounted) {
                        this.setState({
                            _that: JSON.parse(e.data)
                        });
                    }
                };

                this.system.addEventListener('open', function (e) {
                    // Connection was opened.
                    //console.log(e)
                }, false);

                this.system.addEventListener('chats_update', function (e) {
                    // Connection was opened.
                    if (_that._isMounted) {
                        _that.setState({
                            rawChats: JSON.parse(e.data),
                            isLoading: false
                        });
                    }
                }, false);

                this.system.addEventListener('error', function (e) {
                    if (e.readyState == EventSource.CLOSED) {
                        // Connection was closed.
                    }
                }, false);
            }
        } else {
            console.warn("EventSource Streams not supoorted by browser")
            this.getChats()
        }
    }

    getEmails = () => {
        const profileId = this.props.user?this.props.user.id:FakeData.getData("yoo").id ;
        const profileType = this.props.user?this.props.user.type:"F"
        const dataTo = {
            user: FakeData.getData("yoo"),
            profileId,
            profileType
        }
        const _that = this
        const url = "/getEmailList.php?auth0&isFromChat";

        FakeData.post(url, dataTo, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return;
                }
                _that.setState({
                    emails: res
                });

                setTimeout(() => {
                    _that.getEmails()
                }, 1500)
            }),
            error: ((err) => {

            })
        });
    }

    onUserSelect(user, isGroup) {
        const chats = this.state.rawChats;
        let bool = false

        chats.forEach((item, i) => {
            if (!item.isGroup && item.otherUser.id === user.id && item.type !== "event") {
                bool = true
                this.setState({
                    chat: item,
                    activeChatIndex: item.id,
                    isCreateChat: false
                });
            }
        })

        if (!bool) {
            const chat = {
                otherUser: user,
                id: null,
                userOne: FakeData.getData("yoo"),
                userTwo: user,
                messages: [],
                last_msg: null,
                unread: 0,
                isYou: true,
                date: null,
                removedByUserOne: false,
                removedByUserTwo: false,
                type: this.state.activeFilter === "Parents" ? "parent" : FakeData.inArray(this.state.activeFilter, ["Groups", "Teams"]) ? "event" : "timeline",
                target: "new"
            }

            this.setState({
                chat: chat,
                isCreateChat: false
            });
        }
    }

    onChatSelect(chat) {
        this.setState({ chat: chat, isCreateChat: false, activeChatIndex: chat.id });
    }

    _Chats = () => {
        const chats = this.state.rawChats
        let arr = []
        if (this.state.activeFilter === "All") {
            arr = chats;
        } else if (this.state.activeFilter === "Chats") {
            arr = chats.filter((item, i) => {
                return !item.isGroup;
            })
        } else if (this.state.activeFilter === "Groups") {
            arr = chats.filter((item, i) => {
                return item.isGroup
            })
        } else if (this.state.activeFilter === "Events" || this.state.activeFilter === "Teams") {
            arr = chats.filter((item, i) => {
                return item.otherUser.isTeam
            })
        } else if (this.state.activeFilter === "Parents") {
            arr = chats.filter((item, i) => {
                return item.otherUser.isParent;
            })
        } else if (this.state.activeFilter === "Emails") {
            arr = this.state.emails
        }

        return arr;
    }

    setChat = (chat) => {
        let chats = this.state.rawChats;
        chats.forEach((item,i)=>{
            if(item.id===chat.id){
                chats[i] = chat;
                this.setState({rawChats:chats})
            };
        })
    }

    getChatById(id, user) {
        const chats = this.state.rawChats
        let bool = false
        chats.forEach((item, i) => {
            if (item.id === id) {
                bool = true
                this.setState({
                    chat: item,
                    activeChatIndex: item.id
                });
            }
        })

        if (!bool) {
            const chat = {
                otherUser: user,
                id: null,
                userOne: FakeData.getData("yoo"),
                userTwo: user,
                messages: [],
                last_msg: null,
                unread: 0,
                isYou: true,
                date: null,
                removedByUserOne: false,
                removedByUserTwo: false,
                type: "timeline",
                target: "new"
            }

            this.setState({
                chat: chat
            });
        }
    }

    setCreatingChatView = (bool = true) => {
        this.setState({ isCreateChat: bool });
    }

    render() {
        const { chat, activeFilter, isLoading, isCreateChat } = this.state;
        const { isEmbed, isHomeEmbed, mode } = this.props;

        return (
            <div className="chats-app" style={{ width: isEmbed ? "100%" : "90vw" }}>
                {chat === null && !isEmbed &&
                    <Helmet
                        title={"Chats"}
                        meta={[
                            { "name": "description", "content": "" },
                            { property: "og:type", content: "chatApp" },
                            { property: "og:title", content: "Chats" },
                            { property: "og:image", content: "" },
                            { property: "og:url", content: FakeData.baseURL + "/#" + this.props.location.pathname + this.props.location.search }
                        ]}
                    />
                }
                {chat !== null && !isEmbed &&
                    <Helmet
                        title={((this.state.chat.unread > 0) ? "(" + this.state.chat.unread + ") " : "") + (this.state.chat.isGroup) ? "Chat with " + this.state.chat.otherUser.name : this.state.chat.otherUser.name + " - Chats"}
                        meta={[
                            { "name": "description", "content": "Description of page" },
                            { property: "og:type", content: "chatApp" },
                            { property: "og:title", content: ((this.state.chat.unread > 0) ? "(" + this.state.chat.unread + ") " : "") + (this.state.chat.isGroup) ? "Chat with " + this.state.chat.otherUser.name : this.state.chat.otherUser.name + " - Chats" },
                            { property: "og:image", content: "" },
                            { property: "og:url", content: FakeData.baseURL + "/#" + this.props.location.pathname + this.props.location.search }
                        ]}
                    />
                }
                <ChatList isPage={this.props.isPage?true:false} onNewMessage={(msg)=>{
                    this.setChat(msg)
                }} isCreateChat={isCreateChat} isLoading={isLoading} setCreatingChatView={this.setCreatingChatView} key={activeFilter + this._Chats().length} newChat={this.state.chat} activeChatIndex={this.state.activeChatIndex} onUserSelect={this.onUserSelect} onChatSelect={this.onChatSelect} chats={this._Chats()} filters={this.state.filters} activeFilter={this.state.activeFilter} onFilterChange={this.setFilters} />
                <ChatView isPage={this.props.isPage?true:false} onChatDelete={(bool = true) => {
                    this.setState({
                        chat: this._Chats()[0] ? this._Chats()[0] : null
                    });
                }} isCreateChat={isCreateChat} isLoading={isLoading} key={!this.state.chat ? "null-chat" : this.state.chat.isEmail ? "email-" + this.state.chat.id : "chat-" + chat.id} chat={this.state.chat} chatType={activeFilter === "Parents" ? "parent" : FakeData.inArray(activeFilter, ["Groups", "Teams"]) ? "event" : "timeline"} isNewGroup={FakeData.inArray(activeFilter, ["Groups"]) ? true : false} onChatSelect={this.onChatSelect} onUserSelect={this.onUserSelect} />
            </div>
        );
    }
}

export class ChatList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: "",
            isSearching: false,
            isSelecting: false,
            chats: this.props.chats,
            activeChatIndex: 0,
            friends: [],
            isCreatingGroup: false,
            isCreatingEmail: false,
            groupType: "normal",
            filter: ""
        }
    }

    componentWillReceiveProps(nextProps) {
        const _that = this;
        if (this.state.activeChatIndex === 0) {
            nextProps.chats.sort(function (a, b) {
                if (_that.props && _that.props.activeFilter === "Emails") {
                    return b.timestamp - a.timestamp;
                }

                if (b.last_msg === null || a.last_msg === null) {
                    return true;
                } else if(b.last_msg !== null || a.last_msg !== null) {
                    return b.last_msg.timestamp - a.last_msg.timestamp;
                }
            })

            if (nextProps.chats.length > 0) {
                this.setState({
                    activeChatIndex: nextProps.chats[0].id
                });

                this.props.onChatSelect(nextProps.chats[0])
            }
        }

        if (nextProps.activeChatIndex !== 0) {
            this.setState({ activeChatIndex: nextProps.activeChatIndex });
        }

        this.setState({ chats: nextProps.chats });
    }

    onSearchChange(e) {
        this.setState({ value: e.target.value, isSearching: true });
        const list = this.state.friendsData
        const arr = []
        list.forEach((item, i) => {
            if (item.name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1) {
                arr.push(item)
                this.setState({ friends: arr });
            }
        })
    }

    onSearchFocus() {
        this.setState({ isSearching: true, friendsData: FakeData.getData("yoo").friends, friends: FakeData.getData("yoo").friends });
    }

    onSearcBlur() {
        this.setState({ isSearching: (!this.state.isSelecting) ? false : true });
    }

    onNewChatCancel(bool) {
        if (bool) {
            const chats = this.state.chats;
            chats.forEach((item, i) => {
                if (item.id === this.state.activeChatIndex) {
                    this.props.onChatSelect(item)
                }
            })
        } else {

        }
    }

    render() {
        const _that = this;
        this.state.chats.sort(function (a, b) {
            if (_that.props && _that.props.activeFilter === "Emails") {
                return b.timestamp - a.timestamp;
            }
            if (b.last_msg === null || a.last_msg === null) {
                return true;
            }
            return b.last_msg.timestamp - a.last_msg.timestamp;
        })

        const { isCreatingGroup, groupType, isCreatingEmail } = this.state;
        const { isLoading, isCreateChat, setCreatingChatView, isPage, isHomeEmbed, filter } = this.props;
        const _filter = filter ? FakeData.nullify(filter) : "";
        const activeChatIndex = this.props.activeChatIndex ? this.props.activeChatIndex : this.state.activeChatIndex;

        return (
            <div className="chat-left-view" style={isHomeEmbed ? {
                width: "20vw",
                maxWidth: "20vw",
                borderRight: "none"
            } : {}}>
                {(!isHomeEmbed && !isPage) &&
                    <div className="chat-left-header">
                        <span>Chats</span>
                        <img src={"images/compose-message.svg"} style={{ width: "15px", height: "15px", margin: "0px 15px", cursor: "pointer" }} onClick={() => {
                            setCreatingChatView(!isCreateChat);
                        }} />
                    </div>
                }
                <div className="chat-left-body">
                    {(!isHomeEmbed && !isPage) &&
                        <div className="chat-left-body-filter">
                            <div className="filter-search">
                                <i className="material-icons">search</i>
                                <input value={this.state.value} placeholder="Search..." onChange={(e) => this.onSearchChange(e)} onFocus={() => this.onSearchFocus()} onBlur={() => this.onSearcBlur()} />
                            </div>
                            <div className="filter-buttons">
                                {
                                    this.props.filters.map((item, i) => {
                                        if (item === "Teams" && FakeData.getData("yoo").id !== null && FakeData.getData("yoo").ownTeams.length === 0) {
                                            return null;
                                        } else if (item === "Emails" && FakeData.getData("yoo").id !== null && FakeData.getData("yoo").ownTeams.length === 0) {
                                            return null;
                                        } else if (item === "Parents" && FakeData.getData("yoo").id !== null && (FakeData.getData("yoo").coaching.length === 0 || FakeData.getData("yoo").children.length === 0)) {
                                            return null;
                                        } else if (item === "Events" && FakeData.getData("yoo").id !== null && FakeData.getData("yoo").ownTeams.length > 0) {
                                            return null;
                                        }
                                        return (
                                            <div key={i} className={(this.props.activeFilter === item) ? "active" : ""} onClick={() => {
                                                this.props.onFilterChange(item)
                                            }}>{item}</div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    }
                    {this.state.isSearching && !isLoading &&
                        <div className="chat-left-body-content" onMouseOver={() => this.setState({ isSelecting: true })} onMouseLeave={() => this.setState({ isSelecting: false, isSearching: false })}>
                            <h4>Friends</h4>
                            {FakeData.getData("yoo").id !== null &&
                                <div className="chat-friends">
                                    {
                                        this.state.friends.map((item, i) => {
                                            return (
                                                <div key={i} className="chat-friend" onClick={() => {
                                                    this.props.onUserSelect(item)
                                                    this.setState({
                                                        isSelecting: false,
                                                        isSearching: false
                                                    });
                                                }}>
                                                    <img src={item.image} />
                                                    <span>{item.name}</span>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                    }
                    {!this.state.isSearching && !isLoading &&
                        <div className="chat-left-body-content">
                            {this.props.activeFilter === "Groups" && !isPage &&
                                <div className="chat-left-body-content-create">
                                    <span>Create</span>
                                    <div className="chat-left-body-content-create-button">
                                        <span onClick={() => {
                                            this.setState({ isCreatingGroup: true, groupType: "normal" });
                                        }}>Normal</span>
                                        <span onClick={() => {
                                            this.setState({ isCreatingGroup: true, groupType: "parent" });
                                        }}>Parents</span>
                                    </div>
                                    <span>group?</span>
                                </div>
                            }
                            {this.props.activeFilter === "Emails" && !isPage &&
                                <div className="chat-left-body-content-create" style={isHomeEmbed ? {
                                    overflowX: "hidden",
                                    height: "auto"
                                } : {}}>
                                    <span>Create a new </span>
                                    <div className="chat-left-body-content-create-button">
                                        <span onClick={() => {
                                            this.setState({ isCreatingEmail: true });
                                        }}>email</span>
                                    </div>
                                    <span>message?</span>
                                </div>
                            }
                            <div className="chat-left-body-content-chats">
                                {(this.props.newChat !== null && this.props.newChat.target && this.props.isCreateChat) &&
                                    <div className="chat-left-body-content-chat active">
                                        <img src={this.props.newChat.otherUser.image} />
                                        <div className="chat-overview">
                                            <div className="chat-overview-header">
                                                <span style={{ fontWeight: 600, color: "#000" }}>{this.props.newChat.otherUser.name}</span>
                                                <i className="material-icons" onClick={() => this.onNewChatCancel(true)}>close</i>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {this.props.activeFilter !== "Emails" &&
                                    this.state.chats.filter((item) => {
                                        return FakeData.nullify(item.otherUser.name).toLowerCase().indexOf(_filter.toLowerCase()) > -1;
                                    }).map((item, i) => {
                                        if (item.otherUser.isClosed || item.last_msg===null) {
                                            return null;
                                        }

                                        return (
                                            <ChatItem i={i} isHomeEmbed={isHomeEmbed} onNewMessage={(msg)=>{
                                                if(this.props.onNewMessage){this.props.onNewMessage(msg);}
                                            }} chat={item} key={item.id} activeChatIndex={activeChatIndex} onChatSelect={this.props.onChatSelect}/>
                                        )
                                    })
                                }
                                {this.props.activeFilter === "Emails" &&
                                    this.state.chats.map((item, i) => {
                                        return (
                                            <div key={i} className={(this.state.activeChatIndex === item.id) ? "chat-left-body-content-chat active" : "chat-left-body-content-chat"} onClick={() => {
                                                this.setState({
                                                    activeChatIndex: item.id
                                                });

                                                this.props.onChatSelect(item)
                                            }}>
                                                <img src={item.otherUser.image} />
                                                <div className="chat-overview">
                                                    <div className="chat-overview-header">
                                                        <span style={{ fontWeight: "", color: "" }}>{item.otherUser.name}</span>
                                                        <span style={{ fontWeight: "", color: "" }}>{window.moment(item.date).calendar()}</span>
                                                    </div>
                                                    <div className="chat-overview-body">
                                                        <span style={{ fontWeight: "", color: "" }}>{item.subject.substring(0, 20) + "..."}</span>
                                                        {(item.otherUser.id === item.user.id) &&
                                                            <img className="read-icon" src={item.otherUser.image} />
                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                        )
                                    })
                                }
                                {!isLoading && this.state.chats.length === 0 &&
                                    <EmptyState icon={"drafts"} text={"No chats found..."} isShown={true} style={{ width: "99%", height: "20vh" }} />
                                }
                            </div>
                        </div>
                    }

                    {isLoading &&
                        <div className="chat-left-body-content">
                            <LoadingState text={"Loading chats..."} isShown={true} style={{ width: "99%", height: "40vh" }} spinnerStyle={{ width: "20px", height: "20px" }} />
                        </div>
                    }
                </div>
                {isCreatingGroup &&
                    <CreateMessasingGroup isOpen={isCreatingGroup} type={groupType} onClose={(group) => {
                        if (group === null) {
                            this.setState({ isCreatingGroup: false });
                        } else {
                            this.setState({ isCreatingGroup: false });
                            //ToDo
                            this.props.onUserSelect(group, true)
                        }
                    }} />
                }
                {isCreatingEmail &&
                    <CreateMessasingModal withTopic={true} topic={"General"} isFromChat={true} eventToType={"F"} eventToID={FakeData.getData("yoo").id} isOpen={isCreatingEmail} type={"normal"} onClose={(group) => {
                        if (group === null) {
                            this.setState({ isCreatingEmail: false });
                        } else {
                            this.setState({ isCreatingEmail: false });
                        }
                    }} />
                }
            </div>
        );
    }
}

class ChatItem extends Component{
    constructor(props){
        super(props)
        this.state = {
            item : props.chat,
            chatSystem: {status:"offline"},
            msgs: []
        }
    }

    componentDidMount(){
        this._isMounted = true;
        const _that = this;
        const {item, msg} = this.state;

        try {
            this.chat = this.chat = FakeData.socket_connect(_that.state.item.id+"-list");
            let _user = FakeData.getData("yoo");
            delete _user.settings;
            delete _user.hash_key;
            this.chat.on("chat_open", (data)=>{
              _that.setState({ chatSystem: data });
              _that.chat.emit("join_chat", {id: _that.state.item.id});
            })

            this.chat.on("message",(data) => {
                console.log(data)
                let _msg = data;
                _msg['isYou'] = FakeData.getData("yoo").id === data.user.id?true:false;
                if(!_msg['isYou']){
                    _msg['status'] = 'delivered';
                }
                item.last_msg = _msg;
                
                _that.setState({item});
                if(_that.props.onNewMessage){
                    _that.props.onNewMessage(item)
                }
            })
          } catch (error) {
            this.chat = false;
          }
    }

    componentWillUnmount(){
        this._isMounted = false;
        if(this.chat){
            this.chat.emit("leave_chat",{id: this.state.item.id});
            this.chat.disconnect();
            this.chat = false
        };
    }

    render(){
        const {item, msg} = this.state;
        const {activeChatIndex, isHomeEmbed, i } = this.props

        return(
            <div className={(activeChatIndex === item.id) ? "chat-left-body-content-chat active" : "chat-left-body-content-chat"} onClick={() => {
                let _item = item;
                _item.messages.forEach((__item, i)=>{
                    __item.status = 'read'
                });

                this.setState({
                    item: _item
                });

                this.props.onChatSelect(_item)
            }} style={isHomeEmbed ? {
                borderRight: (FakeData.listify(this.state.chats).length - 1 === i) ? "" : "1px solid #eee"
            } : {}}>
                {!item.isGroup &&
                    <img src={item.otherUser.image} />
                }
                {item.isGroup &&
                    <GroupAvatar width="50px" height="50px" margin="10px" data={item.otherUser.members} />
                }
                <div className="chat-overview">
                    <div className="chat-overview-header">
                        {item.last_msg!==null && <span style={{ fontWeight: (item.last_msg.status === "delivered" && !item.last_msg.isYou) ? 600 : "", color: (item.last_msg.status === "delivered" && !item.last_msg.isYou) ? "#000" : "" }}>{item.otherUser.name}</span>}
                        {item.conversation !== null && item.last_msg!==null &&
                            <span style={{ fontWeight: (item.last_msg.status === "delivered" && !item.last_msg.isYou) ? 600 : "", color: (item.last_msg.status === "delivered" && !item.last_msg.isYou) ? "#000" : "" }}>{window.moment(item.last_msg.date).calendar()}</span>
                        }
                    </div>
                    {item !== null &&
                        <div className="chat-overview-body">
                            {item.last_msg!==null && <span style={{ fontWeight: (item.last_msg.status === "delivered" && !item.last_msg.isYou) ? 600 : "", color: (item.last_msg.status === "delivered" && !item.last_msg.isYou) ? "#000" : "" }} dangerouslySetInnerHTML={{__html:(item.last_msg.isYou) ? ((item.last_msg.body.length > 20) ? "You : " + item.last_msg.body.substring(0, 20) + "..." : "You : " + item.last_msg.body.substring(0, 20)) : ((item.last_msg.body.length > 20) ? item.last_msg.body.substring(0, 20) + "..." : item.last_msg.body.substring(0, 30))}}></span>}
                            {this.is && <i className="material-icons">settings</i>}
                            {(item.last_msg!==null && item.last_msg.status === "seen" && item.last_msg.isYou && !item.isGroup) &&
                                <img className="read-icon" src={item.otherUser.image} />
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export class ChatView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isShowingAbout: true,
            isSending: false,
            hasScrolled: false,
            isAdding: false,
            isEdit: false,
            filter: "",
            newMessages: [],
            isOpen: (this.props.isOverLay) ? false : true,
            msg: {
                body: "",
                media: {}
            },
            newMembers: [],
            chat: (this.props.chat === null) ? {
                id: null,
                userOne: {},
                userTwo: {},
                otherUser: {},
                messages: [],
                last_msg: null,
                unread: 0,
                isYou: true,
                date: null,
                removedByUserOne: false,
                removedByUserTwo: false,
                type: "timeline"
            } : this.props.chat
        }
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.state.chat.id !== null && !this.state.chat.isEmail) {
            this.initSystem();
            const _that = this;
            const {chat, msg} = this.state;

            this.setChatSocket();
            const _elem = _that.refs.messages;
            FakeData.$(_elem).animate({ scrollTop: FakeData.$(_elem).prop("scrollHeight")}, 1000);
            this.readAll()
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        if(this.system){
            this.system.close()
        }
        
        if(this.chat){
            this.chat.emit("leave_chat",{id: this.state.chat.id});
            this.chat.disconnect();
            this.chat = false
        };
    }

    componentWillReceiveProps(nextProps) {

    }


    getConversation() {
        const str = "chat" + this.props.chat.id + "you"
        if (this.state.chat.id === null) {
            return;
        } else if (!this.isMounted) {
            return;
        }

        const isPage = this.state.chat.isPage;
        const pageMatch = FakeData.listify(FakeData.getData("yoo").pages).filter((page, i)=>{
            return isPage && (page.id === this.state.chat.user.id && page.type === this.state.chat.user.type || page.id === this.state.chat.otherUser.id && page.type === this.state.chat.otherUser.type)
        });

        const userFrom = pageMatch[0]? pageMatch[0] : {
            type: FakeData.getData("yoo").type,
            id:FakeData.getData("yoo").id
        };

        const dataTo = {
            user: userFrom,
            id: this.state.chat.id
        }
        const _that = this

        FakeData.post("/getChat.php?auth0", dataTo, {
            success: ((res) => {
                if (!_that.isMounted) {
                    return;
                }

                if(_that.state.chat.messages.length > res.messages.length){
                    return;
                }

                _that.setState({
                    chat: res
                });

                setTimeout((() => {
                    _that.getConversation()
                }), 1500)
            }),
            error: ((err) => {

            })
        })
    }

    onSend(cb) {
        const _that = this;
        const isPage = this.state.chat.isPage;
        const pageMatch = FakeData.listify(FakeData.getData("yoo").pages).filter((page, i)=>{
            return isPage && (page.id === this.state.chat.user.id && page.type === this.state.chat.user.type || page.id === this.state.chat.otherUser.id && page.type === this.state.chat.otherUser.type)
        });

        const userFrom = pageMatch[0]? pageMatch[0] : {
            type: FakeData.getData("yoo").type,
            id:FakeData.getData("yoo").id
        };

        const forDummy = pageMatch[0]? true : false;
        const dataTo = {
            userFrom,
            userTo: this.state.chat.isGroup?{
                id: this.state.chat.groupID,
                type: "GC"
              }:{
                id: this.state.chat.otherUser.id,
                type: this.state.chat.otherUser.type
            },
            msg: this.state.msg,
            id: this.state.chat.id,
            isGroup: (this.state.chat.isGroup) ? true : false,
            users: this.state.chat.otherUser.members
        }

        if (this.state.msg.body === "" && !this.state.msg.media.id) {
            this.setState({
                msgError: true
            });
            return;
        }

        const _dummyMsg = {
            "id": null,
            "user": forDummy?this.state.chat.user:FakeData.getData("yoo"),
            "isYou": true,
            "body": this.state.msg.body,
            "date": FakeData.getFullDateString(),
            "media": this.state.msg.media.url ? this.state.msg.media : null,
            "status": "",
            "type": "timeline",
            "timestamp": Math.floor(Date.now() / 1000)
        }

        console.log(_dummyMsg, dataTo)

        if(this.chat){
            this.chat.emit("send_msg", {
                id: this.state.chat.id,
                data: _dummyMsg
            });

            _that.setState({
                msg: {
                    body: "",
                    media: {}
                },
                isSending: false
            });
        } else{
            this.state.chat.messages.push(_dummyMsg);
            this.setState({ chat: this.state.chat, isSending: true });
        }
        
        cb.apply(_that)

        const _elem = this.refs.messages;

        //console.log(dataTo);
        FakeData.post("/replyToChat.php?auth0", dataTo, {
            success: ((res) => {
                //_that.state.chat.messages.unshift(res)
                _that.setState({
                    chat: _that.state.chat,
                    msg: {
                        body: "",
                        media: {}
                    },
                    isSending: false
                });
                //cb.apply(_that)
                //cb.apply(_that)
                //console.log(res);
            }),
            error: ((err) => {

            })
        })
    }

    startConversation(cb) {
        if (this.state.chat.id !== null) {
            return;
        }

        const _that = this
        const dataTo = {
            userFrom: {
                id:FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: {
                id:this.state.chat.otherUser.id,
                type:this.state.chat.otherUser.type
            },
            type: this.state.chat.type,
            msg: this.state.msg,
            profileId: this.state.chat.type === "event" ? this.state.chat.otherUser.id : 0,
            profileType: this.state.chat.type === "event" ? "EG" : "F"
        }

        if (this.state.msg.body === "" && !this.state.msg.media.id) {
            this.setState({
                msgError: true
            });
            return;
        }

        const _dummyMsg = {
            "id": null,
            "user": this.FakeData.getData("yoo"),
            "isYou": true,
            "body": this.state.msg.body,
            "date": FakeData.getFullDateString(),
            "media": this.state.msg.media.url ? this.state.msg.media : null,
            "status": "",
            "type": "timeline",
            "timestamp": Math.floor(Date.now() / 1000)
        }

        this.state.chat.messages.push(_dummyMsg);
        this.setState({ chat: this.state.chat, isSending: true });
        //cb.apply(_that)

        FakeData.post("/startNewchat.php?auth0", dataTo, {
            success: ((res) => {
                //console.log(res);
                if (!_that.isMounted) {
                    return;
                }

                if (res.error) {
                    alert("Conversation Already Exists!!")
                    return
                }
                _that.setState({
                    chat: res,
                    msg: {
                        body: "",
                        media: {}
                    }
                });

                _that.props.onChatSelect(res)


                //cb.apply(_that)
                cb.apply(_that)
                _that.initSystem()
                _that.setChatSocket()
                
            }),
            error: ((err) => {

            })
        }, true, "", null)
    }

    setChatSocket = () => {
        const _that = this;
        const {chat, msg, newMessages} = this.state;

        try {
            this.chat = FakeData.socket_connect(_that.state.chat.id);
            let _user = FakeData.getData("yoo");
            delete _user.settings;
            delete _user.hash_key;
            this.chat.on("chat_open", (data)=>{
                _that.setState({ chatSystem: data });
                _that.chat.emit("join_chat", {id: _that.state.chat.id});
            })

            this.chat.on("message",(data) => {
                let _msg = data;
                
                let isYourPage = false;
                if(this.state.chat.isPage){
                    const isPage = this.state.chat.isPage;
                    const pageMatch = FakeData.listify(FakeData.getData("yoo").pages).filter((page, i)=>{
                        return isPage && (page.id === this.state.chat.user.id && page.type === this.state.chat.user.type || page.id === this.state.chat.otherUser.id && page.type === this.state.chat.otherUser.type)
                    });

                    isYourPage = pageMatch[0]? true : false
                } 

                _msg['isYou'] = isYourPage?isYourPage:FakeData.getData("yoo").id === data.user.id?true:false;
                if(_msg['isYou']){
                    const _elem = _that.refs.messages;
                    FakeData.$(_elem).animate({ scrollTop: FakeData.$(_elem).prop("scrollHeight")}, 1000);
                } else{
                    const _elem = _that.refs.messages
                    if(FakeData.$(_elem).scrollTop() < FakeData.$(_elem).prop("scrollHeight")){
                        newMessages.push(_msg);
                    }
                }
                chat.messages.push(_msg);
                
                _that.setState({chat, newMessages});
            })
        } catch (error) {
                this.chat = false;
        }
    }

    readAll() {
        const str = "chat" + this.state.chat.id + "you"
        if (this.state.chat.id === null) {
            return;
        } else if (!FakeData.isMounted(str)) {
            //return;
        }

        const dataTo = {
            user: FakeData.getData('yoo'),
            conversationId: this.state.chat.id
        }
        const _that = this

        FakeData.post("/readConversation.php?auth0", dataTo, {
            success: ((res) => {

            }),
            error: ((err) => {

            })
        })
    }

    initSystem = () => {
        if (EventSource) {
            const isPage = this.state.chat.isPage;
            const pageMatch = FakeData.listify(FakeData.getData("yoo").pages).filter((page, i)=>{
                return isPage && (page.id === this.state.chat.user.id && page.type === this.state.chat.user.type || page.id === this.state.chat.otherUser.id && page.type === this.state.chat.otherUser.type)
            });

            const userFrom = pageMatch[0]? pageMatch[0] : {
                type: FakeData.getData("yoo").type,
                id:FakeData.getData("yoo").id
            };
            this.system = new EventSource(FakeData.fetchURL+ '/getChat.php?auth0&isStream&userId=' + userFrom.id + '&userType='+userFrom.type+'&id=' + this.state.chat.id);
            const _that = this;
            if (this.system !== null) {
                //this.system.addEventListener()
                this.system.onmessage = function (e) {
                    if (_that._isMounted) {
                        this.setState({
                            _that: JSON.parse(e.data)
                        });
                    }
                };

                this.system.addEventListener('open', function (e) {
                    // Connection was opened.
                    //console.log(e)
                }, false);

                this.system.addEventListener('chat_update', function (e) {
                    // Connection was opened.
                    if (_that._isMounted) {
                        let data = JSON.parse(e.data)
                        if(_that.state.chat.messages.length > data.messages.length){
                            return;
                        }
                        _that.setState({
                            chat: data
                        });

                        if (!_that.state.isSending) {
                            FakeData.loaderElement().style.marginBottom = "-2cm";
                        }
                    }
                }, false);

                this.system.addEventListener('error', function (e) {
                    if (e.readyState == EventSource.CLOSED) {
                        // Connection was closed.
                    }
                }, false);
            }
        } else {
            console.warn("EventSource Streams not supoorted by browser")
            this.getConversation()
        }
    }

    parseMessages = (msgs = []) => {
        const timeList = [];
        const messageTimeList = {};
        msgs.forEach((m, i) => {
            var ago = FakeData.moment(m.date).calendar();
            if (!FakeData.inArray(ago, timeList)) {
                timeList.push(ago);
                messageTimeList[ago] = [];
            }
        });

        msgs.forEach((m, i) => {
            var ago = FakeData.moment(m.date).calendar();
            FakeData.listify(messageTimeList[ago]).push(m);
        });

        return {
            times: timeList,
            messages: messageTimeList
        };
    }

    addGroupMember = () => {
        const { chat, newMembers } = this.state;
        if (newMembers.length === 0) {
            this.setState({ isAdding: false });
            return;
        }
        const _that = this;
        const _data = {
            groupId: chat.groupID,
            members: newMembers,
            convoId: chat.id,
            adminId: FakeData.getData("yoo").id,
            groupName: chat.otherUser.name
        }

        console.log(_data)
        const url = "/createGroup.php?auth0&isAddMember";
        FakeData.post(url, _data, {
            success(res) {
                _that.setState({ isAdding: false });
            },
            error(e) {
                _that.setState({ isAdding: false });
            }
        }, true, "", () => { })
    }

    leaveGroup = (member = { id: 0 }) => {
        const { chat, filter } = this.state;
        const _that = this;
        const _data = {
            groupId: chat.groupID,
            memberId: member.id,
            convoId: chat.id
        }

        console.log(_data)
        const url = "/createGroup.php?auth0&isLeaveGroup";
        FakeData.post(url, _data, {
            success(res) {
                if (_that.props.onChatDelete) {
                    _that.props.onChatDelete()
                }
            },
            error(e) {
                if (_that.props.onChatDelete) {
                    _that.props.onChatDelete()
                }
            }
        }, true, "", () => { })
    }

    closeGroup = () => {
        const { chat, filter } = this.state;
        const _that = this;
        const _data = {
            groupId: chat.groupID,
            adminId: FakeData.getData("yoo").id,
            convoId: chat.id
        }

        console.log(_data)
        const url = "/createGroup.php?auth0&isCloseGroup";
        FakeData.post(url, _data, {
            success(res) {
                chat.otherUser.isClosed = true;
                _that.setState({ chat });
            },
            error(e) {
                _that.setState({ chat });
            }
        }, true, "", () => { })
    }

    deleteGroup = () => {
        const { chat, filter } = this.state;
        const _that = this;
        const _data = {
            groupId: chat.groupID,
            convoId: chat.id
        }

        console.log(_data)
        const url = "/createGroup.php?auth0&isDelGroup";
        FakeData.post(url, _data, {
            success(res) {
                if (_that.props.onChatDelete) {
                    _that.props.onChatDelete()
                }
            },
            error(e) {
                if (_that.props.onChatDelete) {
                    _that.props.onChatDelete()
                }
            }
        }, true, "", () => { })
    }

    onUserSelect = (item) => {
        const { newMembers } = this.state;
        let bool = false;
        newMembers.forEach((_item, i) => {
            if (_item.id === item.id) {
                bool = true;
            }
        })

        if (!bool) {
            newMembers.push(item);
            this.setState({ newMembers });
        } else {
            const _list = newMembers.filter((_item, i) => {
                return _item.id !== item.id;
            })

            this.setState({ newMembers: _list });
        }
    }

    inMembers = (item) => {
        const { chat } = this.state;
        let bool = false;
        if (!chat.isGroup) {
            return false;
        }

        chat.otherUser.members.forEach((_item, i) => {
            if (_item.id === item.id) {
                bool = true;
            }
        });

        return bool;
    }

    inNewMembers = (item) => {
        const { newMembers } = this.state;
        let bool = false;
        newMembers.forEach((_item, i) => {
            if (_item.id === item.id) {
                bool = true;
            }
        });

        return bool;
    }

    leaveChat = () => {
        const { chat } = this.state;
        const isYou = FakeData.getData("yoo").id === chat.userOne.id ? true : false;
        console.log(isYou ? "User one leaving" : "User two leaving")
        const _that = this;
        const _data = {
            isUserOne: isYou,
            userId: FakeData.getData("yoo").id,
            convoId: chat.id
        }

        console.log(_data)
        const url = "/createGroup.php?auth0&isLeaveChat";
        FakeData.post(url, _data, {
            success(res) {
                if (_that.props.onChatDelete) {
                    _that.props.onChatDelete()
                }
            },
            error(e) {
                if (_that.props.onChatDelete) {
                    _that.props.onChatDelete()
                }
            }
        }, true, "", () => { })
    }

    render() {
        const { isCreateChat, isHomeEmbed } = this.props;
        const { chat, filter } = this.state;
        const friends = FakeData.listify(FakeData.getData("yoo").friends);
        const _style = {
            background: "transparent",
        }

        if (this.props.isLoading && !isCreateChat) {
            return (
                <div className="chat-right-view" style={isHomeEmbed ? _style : {}}>
                    <LoadingState text={"Loading chats..."} isShown={true} style={{ width: "100%", height: "100%" }} />
                </div>
            );
        }

        if (this.props.chat === null && !isCreateChat) {
            return (
                <div className="chat-right-view" style={{
                    background: "#fff"
                }}>
                    <EmptyState text={"Start a chat or group chat"} icon={"drafts"} isShown={true} style={{ width: "100%", height: "100%" }} />
                </div>
            );
        }

        if (!this.props.isLoading && isCreateChat) {
            return (
                <div className="chat-right-view" style={{background: "#fff"}}>
                    <div className="chat-right-view-header">
                        <div className="chat-author">
                            <span>{"New Chat"}</span>
                            <span>{""}</span>
                        </div>
                    </div>
                    <div className="chat-right-view-body">
                        <div className="chat-right-view-body-chats" tabIndex="1" onFocus={() => {
                            //this.readAll()
                        }} style={{ padding: "20px" }}>
                            <div className={"input-field"} style={{ marginTop: "10px" }}>
                                <span>Search</span>
                                <input value={filter} style={{ padding: "4px" }} onChange={(e) => {
                                    this.setState({ filter: e.target.value });
                                }} />
                            </div>

                            <div className={"documents-player-select"}>
                                {
                                    friends.filter((item, i) => {
                                        return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
                                    }).map((item, i) => {
                                        return (
                                            <div className={"documents-player-select-item"} key={i} onClick={() => this.props.onUserSelect(item)}>{item.name}</div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        if (chat.isEmail) {
            return (
                <div className="chat-right-view" style={{background: "#fff"}}>
                    <div className="chat-right-view-header">
                        <div className="chat-author">
                            <span>{chat.otherUser.name}</span>
                            <span>{chat.otherUser.status}</span>
                        </div>
                    </div>
                    <div className="chat-right-view-body">
                        <div className="chat-right-view-body-chats" tabIndex="1" onFocus={() => {
                            //this.readAll()
                        }}>
                            <div className="chat-right-view-mail" style={{ padding: "10px", overflowY: "auto" }} dangerouslySetInnerHTML={{ __html: chat.message }}>

                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        const { times, messages } = this.parseMessages(chat.messages);

        return (
            <div className="chat-right-view" style={isHomeEmbed ? _style : {}}>
                <div className="chat-right-view-header" style={isHomeEmbed ? {
                    background: "#fff"
                } : {}}>
                    <div className="chat-author">
                        <span>{chat.otherUser ? chat.otherUser.name : ""}</span>
                        <span>{chat.otherUser ? chat.otherUser.status : ""}</span>
                    </div>
                    {chat.otherUser && !chat.otherUser.isClosed && this.props.chat !== null &&
                        <i className="material-icons" onClick={() => {
                            if (chat.isGroup && chat.otherUser.isAdmin) {
                                if (window.confirm("Are you sure you want to close this group?")) {
                                    this.closeGroup();
                                }
                            } else if (chat.isGroup && this.inMembers(FakeData.getData("yoo"))) {
                                if (window.confirm("Are you sure you want to leave this group?")) {
                                    this.leaveGroup(FakeData.getData("yoo"))
                                }
                            } else {
                                if (window.confirm("Are you sure you want to close this chat?")) {
                                    this.leaveChat()
                                }
                            }
                            this.setState({
                                isDeleting: (this.state.isDeleting) ? false : true
                            });
                        }}>{"delete"}</i>
                    }

                    {chat.otherUser && chat.isGroup && chat.otherUser.isClosed &&
                        <i className="material-icons" onClick={() => {
                            if (chat.isGroup && chat.otherUser.isAdmin) {
                                if (window.confirm("Are you sure you want to delete this group?")) {
                                    this.deleteGroup();
                                }
                            } else if (chat.isGroup && this.inMembers(FakeData.getData("yoo"))) {
                                this.leaveGroup(FakeData.getData("yoo"))
                            }
                        }}>{"delete_forever"}</i>
                    }

                    {chat.isGroup && !this.state.isEdit && !chat.otherUser.isClosed &&
                        <i className="material-icons" style={{
                            background: this.state.isAdding ? "#eee" : ""
                        }} onClick={() => {
                            if (this.state.isAdding) {
                                this.addGroupMember()
                                return;
                            }
                            this.setState({
                                isAdding: true
                            });
                        }}>{this.state.isAdding ? "save" : "person_add"}</i>
                    }

                    {chat.isGroup && !this.state.isAdding && chat.otherUser.isAdmin && !chat.otherUser.isClosed &&
                        <i className="material-icons" style={{
                            background: this.state.isEdit ? "#eee" : ""
                        }} onClick={() => {
                            this.setState({
                                isEdit: (this.state.isEdit) ? false : true
                            });
                        }}>{this.state.isEdit ? "close" : "edit"}</i>
                    }

                    {this.props.chat !== null &&
                        <i className="material-icons" onClick={() => {
                            this.setState({
                                //isShowingAbout: (this.state.isShowingAbout) ? false : true
                            });
                        }}>{(this.state.isShowingAbout) ? "error" : "error_outline"}</i>
                    }
                </div>
                <div className="chat-right-view-body" style={isHomeEmbed ? {
                    marginTop: "10px",
                    display: !this.state.isAdding ? "none" : "",
                    padding: "10px",
                    flexDirection: "column"
                } : {
                        display: !this.state.isAdding ? "none" : "",
                        padding: "10px",
                        flexDirection: "column"
                    }}>
                    <div className={"input-field"} style={{ marginTop: "10px" }}>
                        <span>Search</span>
                        <input value={filter} style={{ padding: "4px" }} onChange={(e) => {
                            this.setState({ filter: e.target.value });
                        }} />
                    </div>

                    <div className={"documents-player-select"}>
                        {
                            friends.filter((item, i) => {
                                return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 && !this.inMembers(item);
                            }).map((item, i) => {
                                return (
                                    <div className={this.inNewMembers(item) ? "documents-player-select-item active" : "documents-player-select-item"} key={i} onClick={() => this.onUserSelect(item)}>{item.name}</div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="chat-right-view-body" style={isHomeEmbed ? {
                    marginTop: "10px",
                    display: this.state.isAdding ? "none" : ""
                } : {
                        display: this.state.isAdding ? "none" : ""
                    }}>
                    <div className="chat-right-view-body-chats" tabIndex="1" onFocus={() => {
                        this.readAll()
                    }} style={isHomeEmbed ? {
                        background: "#fff",
                        marginRight: "10px"
                    } : {}}>
                        <div className="chat-right-view-body-chats-list" ref={"messages"}>
                            {this.state.newMessages.length > 0 && (FakeData.$(this.refs.messages).scrollTop() < FakeData.$(this.refs.messages).prop("scrollHeight")) &&
                                <div className={"chat-right-view-body-chats-list-alert"} style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "100%",
                                    background: "#4ac",
                                    color: "#fff",
                                    lineHeight: "40px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    position: "fixed",
                                    zIndex: 10
                                }} onClick={()=>{
                                    const _elem = this.refs.messages;
                                    FakeData.$(_elem).animate({ scrollTop: FakeData.$(_elem).prop("scrollHeight")}, 1000);
                                    this.setState({ newMessages: [] });
                                }}>
                                    {this.state.newMessages.length}
                                </div>
                            }
                            <div className="chat-right-view-body-chats-list-items">
                                {chat.otherUser && chat.otherUser.name && <span className={"chat-msg-time"}>Chat with {chat.otherUser.name}</span>}
                                <span className={"chat-msg-log"}>{chat.messages.length === 0 ? "No messages yet!" : "Chat created : " + FakeData.moment(chat.date).calendar()}</span>
                            </div>
                            {
                                times.map((date, d) => {
                                    return (
                                        <div key={date} className="chat-right-view-body-chats-list-items">
                                            <span className={"chat-msg-time"}>{date}</span>
                                            {
                                                FakeData.listify(messages[date]).map((item, i) => {
                                                    if (item.isLog) {
                                                        return (
                                                            <span key={item.id} className={"chat-msg-log"}>{item.body}</span>
                                                        )
                                                    } else {
                                                        return (
                                                            <ChatMessage
                                                                canScroll={i === FakeData.listify(messages[date]).length - 1 ? true : false}
                                                                hasScrolled={this.state.hasScrolled}
                                                                isGroup={chat.isGroup}
                                                                classThem={(!item.isYou && FakeData.listify(messages[date])[i + 1] && (!FakeData.listify(messages[date])[i + 1].isYou && !FakeData.listify(messages[date])[i + 1].isLog)) ? ((!item.isYou && FakeData.listify(messages[date])[i - 1] && (!FakeData.listify(messages[date])[i - 1].isYou && !FakeData.listify(messages[date])[i - 1].isLog) && FakeData.listify(messages[date])[i + 1] && (!FakeData.listify(messages[date])[i + 1].isYou) && !FakeData.listify(messages[date])[i + 1].isLog) ? "middle-them" : (!item.isYou && FakeData.listify(messages[date])[i - 1] && (!FakeData.listify(messages[date])[i - 1].isYou && !FakeData.listify(messages[date])[i - 1].isLog)) ? "" : "start-them") : "end-them"}
                                                                classYou={(item.isYou && FakeData.listify(messages[date])[i + 1] && (FakeData.listify(messages[date])[i + 1].isYou && !FakeData.listify(messages[date])[i + 1].isLog)) ? ((item.isYou && FakeData.listify(messages[date])[i - 1] && (FakeData.listify(messages[date])[i - 1].isYou && !FakeData.listify(messages[date])[i - 1].isLog) && FakeData.listify(messages[date])[i + 1] && (FakeData.listify(messages[date])[i + 1].isYou) && !FakeData.listify(messages[date])[i + 1].isLog) ? "middle-you" : (item.isYou && FakeData.listify(messages[date])[i - 1] && (FakeData.listify(messages[date])[i - 1].isYou && !FakeData.listify(messages[date])[i - 1].isLog)) ? "" : "start-you") : "end-you"}
                                                                msg={item}
                                                                key={item.timestamp} />
                                                        )
                                                    }
                                                })
                                            }
                                        </div>
                                    )
                                })
                            }
                            {this.is &&
                                chat.messages.map((item, i) => {
                                    if (item.isTime) {
                                        return (
                                            <div key={i}>{item.value}</div>
                                        )
                                    }

                                    return (
                                        <ChatMessage canScroll={i === (chat.messages) ? true : false} hasScrolled={this.state.hasScrolled} isGroup={chat.isGroup} classThem={(!item.isYou && chat.messages[i + 1] && !chat.messages[i + 1].isYou) ? ((!item.isYou && chat.messages[i - 1] && !chat.messages[i - 1].isYou && chat.messages[i + 1] && !chat.messages[i + 1].isYou) ? "middle-them" : (!item.isYou && chat.messages[i - 1] && !chat.messages[i - 1].isYou) ? "" : "start-them") : "end-them"} classYou={(item.isYou && chat.messages[i + 1] && chat.messages[i + 1].isYou) ? ((item.isYou && chat.messages[i - 1] && chat.messages[i - 1].isYou && chat.messages[i + 1] && chat.messages[i + 1].isYou) ? "middle-you" : (item.isYou && chat.messages[i - 1] && !chat.messages[i - 1].isYou && chat.messages[i + 1] && !chat.messages[i + 1].isYou) ? "" : "start-you") : "end-you"} msg={item} key={item.timestamp} />
                                    )
                                })
                            }
                        </div>
                        {!chat.otherUser.isClosed && this.props.chat !== null &&
                            <ChatTextBox error={this.state.msgError} isPublic="true" onBodyChange={(text) => {
                                this.state.msg.body = text
                                this.setState({
                                    msg: this.state.msg,
                                    msgError: false
                                });
                            }} onFileChange={(file) => {
                                this.state.msg.media = file
                                this.setState({
                                    msg: this.state.msg,
                                    msgError: false
                                });
                            }} onEnter={(cb) => {
                                if (this.state.chat.id === null) {
                                    this.startConversation(cb)
                                } else {
                                    this.onSend(cb)
                                }
                            }} sendOnEnter="true" />
                        }
                    </div>
                    {this.state.isShowingAbout && this.props.chat !== null &&
                        <ChatDetails isHomeEmbed={isHomeEmbed} chatId={chat.id} isEditGroup={this.state.isEdit} user={chat.otherUser} messages={chat.messages} />
                    }
                </div>
            </div>
        );
    }
}

class ChatDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            media: [],
            memberOffset: false,
            mediaOffset: false
        }
    }

    getMediaFiles(arr) {
        const newArr = []
        arr.forEach((item, i) => {
            if (item.media !== null) {
                newArr.push(item)
            }
        })

        return newArr;
    }

    removeGroupMember = (member = { id: 0 }, group = { id: 0 }) => {
        console.log(member)
        console.log(group)
        const _that = this;
        const _data = {
            groupId: group.id,
            memberId: member.id,
            adminId: FakeData.getData("yoo").id,
            convoId: this.props.chatId
        }

        console.log(_data)
        const url = "/createGroup.php?auth0&isRemoveFromGroup";
        FakeData.post(url, _data, {
            success(res) {

            },
            error(e) {

            }
        }, true, "", () => { })
    }

    editGroup = (member = { id: 0 }, group = { id: 0 }) => {
        console.log(member)
        console.log(group)
        const _that = this;
        const _data = {
            groupId: group.id,
            memberId: member.id,
            adminId: FakeData.getData("yoo").id,
            convoId: this.props.chatId
        }

        console.log(_data)
        const url = "/createGroup.php?auth0&isEditGroup";
        FakeData.post(url, _data, {
            success(res) {

            },
            error(e) {

            }
        }, true, "", () => { })
    }

    render() {
        const user = this.props.user;
        const { mediaOffset, memberOffset } = this.state;
        const { isHomeEmbed } = this.props;
        var index = isHomeEmbed ? 10 : 4;
        const media = this.getMediaFiles(this.props.messages);
        return (
            <div className="chat-right-view-body-about" style={isHomeEmbed ? {
                borderLeft: "none"
            } : {}}>
                <div className="chat-right-view-body-about-head" style={isHomeEmbed ? {
                    background: "#fff"
                } : {}}>
                    {!user.members &&
                        <img src={user.image} />
                    }
                    {user.members &&
                        <GroupAvatar width="100px" height="100px" margin="10px" data={user.members} />
                    }
                    <span>{user.name}</span>
                    <span>{user.status}</span>
                </div>
                <div className="chat-right-view-body-about-body">
                    {user.members &&
                        <ChatDetailItem isHomeEmbed={isHomeEmbed} label="Members">
                            <div className="chat-group-members">
                                {
                                    user.members.map((item, i) => {
                                        if (!memberOffset && i >= index) {
                                            return null;
                                        }
                                        return (
                                            <div key={i} className={this.props.isEditGroup ? "chat-group-member edit" : "chat-group-member"}>
                                                <img src={item.image} />
                                                {user.isAdmin &&
                                                    <i className="material-icons" onClick={() => {
                                                        this.removeGroupMember(item, user)
                                                    }}>close</i>
                                                }
                                            </div>
                                        )
                                    })
                                }
                                {user.members.length > 4 &&
                                    <div className="chat-group-members-button" onClick={() => {
                                        this.setState({ memberOffset: !memberOffset });
                                    }}>{memberOffset ? "Show less" : "Show All"}</div>
                                }
                            </div>
                        </ChatDetailItem>
                    }

                    {media.length > 0 &&
                        <ChatDetailItem isHomeEmbed={isHomeEmbed} label="Media">
                            <div className="chat-shared-media">
                                {
                                    media.map((item, i) => {
                                        if (!mediaOffset && i >= 9) {
                                            return null;
                                        }
                                        return (<div className={(item.media.type === "image") ? "chat-shared-media-item" : "chat-shared-media-item video"} key={i}>
                                            <MediaItem file={item.media} />
                                        </div>)
                                    })
                                }
                                {media.length > 9 &&
                                    <div className="chat-group-members-button" onClick={() => {
                                        this.setState({ mediaOffset: !mediaOffset });
                                    }}>{mediaOffset ? "Show less" : "Show All"}</div>
                                }
                            </div>
                        </ChatDetailItem>
                    }
                </div>
            </div>
        );
    }
}

export class MediaItem extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        if (this.props.file.type === "image") {
            return (<img style={{ width: "100%", height: "100%" }} className={this.props.className} src={this.props.file.url} />)
        } else if (this.props.file.type === "video") {
            return (<video style={{ width: "100%" }} className={this.props.className} src={this.props.file.url} controls controlsList="nodownload noremote" preload="none" />)
        } else {
            return null;
        }
    }
}

class ChatDetailItem extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const user = this.props.user;
        const { isHomeEmbed } = this.props;

        return (
            <div className="chat-right-view-body-about-body-item" style={isHomeEmbed ? {
                background: "#fff",
                marginTop: "10px"
            } : {}}>
                <span>{this.props.label}</span>
                <div>{this.props.children}</div>
            </div>
        );
    }
}

class GroupAvatar extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="group-avatar" style={{ width: this.props.width, height: this.props.height, margin: this.props.margin }}>
                {
                    this.props.data.map((item, i) => {
                        if (i >= 4) {
                            return null;
                        }

                        return (
                            <img src={item.image} key={i} />
                        )
                    })
                }
            </div>
        );
    }
}

export class ChatMessage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user: null
        }
    }

    componentDidMount(){

    }

    render() {
        const item = this.props.msg
        return (
            <div className={(item.isYou) ? "chat-msg you " + this.props.classYou : "chat-msg " + this.props.classThem + ((this.props.isGroup) ? " group-msg" : " user-msg")} style={{
                background: item.media !== null ? "transparent" : ""
            }}>
                {(!item.isYou) &&
                    <div className="user-image">
                        <img src={item.user.image} />
                        {this.props.classThem === "end-them" && <span className="user-image-online" style={{
                            background: item.user.status === "online" ? "green" : "grey"
                        }}></span>}
                    </div>
                }
                {(item.isYou) &&
                    <div className="user-image-read">
                        {item.status === "seen" && this.props.classYou === "end-you" && <img src={item.user.image} />}
                        {item.status !== "seen" && this.props.classYou === "end-you" && <span style={{
                            background: item.status === "sent" ? "grey" : "#4ac"
                        }}></span>}
                        {this.props.classYou !== "end-you" && <span style={{
                            background: "none"
                        }}></span>}
                    </div>
                }
                {item.media !== null &&
                    <MediaItem className={FakeData.nullify(item.body).length === 0 ? "" : item.isYou ? "image-end" : "image-end them"} file={item.media} />
                }
                <span className={item.media !== null ? (item.isYou ? "msg-end" : "msg-end them") : "msg"} dangerouslySetInnerHTML={{ __html: item.body }}></span>
            </div>
        );
    }
}

export class CreateMessasingGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: "",
            type: "Player",
            topic: "General",
            topics: [
                "General",
                "Announcements",
                "Game",
                "Team Event",
                "Training",
                "Accounts",
                "Social",
                "Schedules",
                "Meeting",
                "Fundraising",
                "Clases",
                "Tournaments",
                "Camps"
            ],
            group: {
                id: null,
                name: "",
                members: [],
                file: { id: null, name: "" },
                team: { id: null, name: "" },
                teams: [],
                users: [],
                tags: []
            },
            errors: {
                name: false,
                members: false,
                file: false,
                team: false,
                topic: false,
                type: false,
                teams: false
            },
            isAll: false,
            isAllTeams: false,
            tFilter: ""
        }

        this.onFilesPicked = this.onFilesPicked.bind(this);
    }

    onFilesPicked = (files) => {
        const _that = this
        const { group } = this.state;
        const file = files[0]
        let reader = new FileReader()
        reader.onloadend = () => {
            const newFile = {
                file: file,
                progress: 0,
                url: reader.result
            }

            group.file = newFile;

            _that.setState({
                group
            });

            this.uploadFile(newFile)
        }
        reader.readAsDataURL(file)
    }

    uploadFile = (file) => {
        var formdata = new FormData();
        const _that = this;
        const { toId, toType } = this.props
        formdata.append("file", file.file);
        formdata.append("location", "");
        formdata.append("albumId", 0);
        formdata.append("tags", "");
        formdata.append("toId", this.props.toId);
        formdata.append("objType", "group-profile");
        var ajax = new XMLHttpRequest();
        ajax.upload.addEventListener("progress", (e) => {
            let percent = Math.round((e.loaded / e.total) * 100);
            _that.state.group.file.progress = percent;
            _that.state.errors.file = (percent < 95) ? true : false;
            _that.setState({
                doc: _that.state.doc,
                errors: _that.state.errors
            });
        }, false);
        ajax.addEventListener("load", (e) => {
            let data = JSON.parse(e.target.responseText)
            data.oldUrl = file.url
            _that.state.group.file = data;
            _that.state.errors.file = false;
            _that.setState({
                group: _that.state.group,
                errors: _that.state.errors
            });
        }, false);
        ajax.open("POST", FakeData.URL + "/uploadMedia.php?auth0&userType=F&userId=" + FakeData.getData("yoo").id + "&type=" + this.props.toType);
        ajax.send(formdata);
    }

    setPlayers = (tag, isTag = true) => {
        const { group, errors, filter } = this.state
        if (isTag) {
            if (!FakeData.inArray(tag, group.members)) {
                group.members.push(tag)
                errors.members = false
                this.setState({ errors, group });
            } else {
                const _index = group.members.indexOf(tag);
                group.members.splice(_index, 1)
                errors.members = group.members.length < 1 ? true : false
                this.setState({ errors, group });
            }
        } else {
            if (!this.inMembers(tag, group.members)) {
                group.users.push(tag)
                errors.members = false
                this.setState({ errors, group });
            } else {
                const _index = group.users.indexOf(tag);
                group.users.splice(_index, 1)
                errors.members = group.users.length < 1 ? true : false
                this.setState({ errors, group });
            }
        }
    }

    inMembers = (item, arr = []) => {
        const _list = arr.filter((_item) => {
            return item.id === _item.id;
        })

        return _list.length > 0 ? true : false
    }

    setTeams = (tag) => {
        const { group, errors, filter } = this.state
        if (!this.inArray("id", tag, group.teams)) {
            group.teams.push(tag)
            errors.teams = false
            this.setState({ errors, group });
        } else {
            const _index = group.teams.indexOf(tag);
            group.teams.splice(_index, 1)
            errors.teams = group.teams.length < 1 ? true : false
            this.setState({ errors, group });
        }
    }

    inArray = (id = "", item, arr = []) => {
        const _list = arr.filter((_item) => {
            return item.activeSquad[id] === _item.activeSquad[id];
        })

        return _list.length > 0 ? true : false
    }

    save = () => {
        const { group, errors, isAll, topic } = this.state
        const friends = FakeData.listify(FakeData.getData("yoo").friends);

        if (group.file.id === null) {
            errors.file = true;
            this.setState({ errors });
            return;
        }

        if (group.name === "" || group.name.length < 3) {
            errors.name = true;
            this.setState({ errors });
            return;
        }

        if (isAll) {
            const list = [];
            friends.forEach((item, i) => {
                list.push(item.id + "^F");
            });

            group.members = list;
            errors.members = false;
            this.setState({ errors, group });
        }

        if (group.members.length === 0) {
            errors.members = true;
            this.setState({ errors });
            return;
        }

        const _that = this;
        console.log(group);

        const dataTo = {
            group,
            id: (this.props.isEdit) ? this.props.data.id : 0,
            team: (this.props.isEdit) ? this.props.data.team : (this.props.isTeam) ? this.state.team : null,
            userFrom: FakeData.getData("yoo").id,
            type: this.props.type.toLowerCase(),
            teamType: "F",
            topic,
            tags: group.tags.join(",")
        }

        FakeData.post((this.props.isEdit) ? "/editGroup.php?auth0&fromChat" : "/createGroup.php?auth0&fromChat", dataTo, {
            success: ((res) => {
                if (this.props.isEdit) {
                    //console.log(res);
                    this.props.onClose(null)
                    return
                }

                this.props.onClose(res)
                FakeData.alert("Group was created!")
            }),
            error: ((err) => {

            })
        }, true, "", (d) => { })
    }

    saveTeamgroup = () => {
        const { group, errors, isAll, type, topic } = this.state
        const friends = FakeData.listify(FakeData.getData("yoo").friends);

        if (group.name === "" || group.name.length < 3) {
            errors.name = true;
            this.setState({ errors });
            return;
        }

        if (isAll && type === "Parent") {
            const list = [];
            const _tags = [];
            group.teams.forEach((team) => {
                if (!FakeData.inArray(team.id + "^T_" + team.activeSquad.id + "^S", _tags)) {
                    _tags.push(team.id + "^T_" + team.activeSquad.id + "^S");
                }
                this.getParents(team).forEach((item, i) => {
                    if (!FakeData.inArray(item.id + "^F", group.members)) {
                        list.push(item.id + "^F");
                    }
                });
            })

            group.members = list;
            errors.members = false;
            group.tags = _tags;
            this.setState({ errors, group });
        } else if (isAll && type === "Player") {
            const list = [];
            const _tags = [];
            group.teams.forEach((team) => {
                if (!FakeData.inArray(team.id + "^T_" + team.activeSquad.id + "^S", _tags)) {
                    _tags.push(team.id + "^T_" + team.activeSquad.id + "^S");
                }
                team.players.forEach((item, i) => {
                    if (!FakeData.inArray(item.userId + "^F", group.members)) {
                        list.push(item.userId + "^F");
                    }
                });
            })

            group.members = list;
            errors.members = false;
            group.tags = _tags;
            this.setState({ errors, group });
        } else {
            const list = [];
            const _tags = [];
            group.teams.forEach((team) => {
                if (!FakeData.inArray(team.id + "^T_" + team.activeSquad.id + "^S", _tags)) {
                    _tags.push(team.id + "^T_" + team.activeSquad.id + "^S");
                }
            })

            group.users.forEach((item, i) => {
                if (!FakeData.inArray(item.id + "^F", group.members)) {
                    list.push(item.id + "^F");
                }
            });

            group.members = list;
            errors.members = false;
            group.tags = _tags;
            this.setState({ errors, group });
        }

        if (group.members.length === 0) {
            errors.members = true;
            this.setState({ errors });
            return;
        }

        const _that = this;
        console.log(group);

        const dataTo = {
            group,
            id: (this.props.isEdit) ? this.props.data.id : 0,
            userFrom: FakeData.getData("yoo").id,
            type: "normal",
            teamType: this.props.eventToType ? this.props.eventToType : "T",
            team: (this.props.isEdit) ? this.props.data.team : group.teams[0],
            topic,
            tags: group.tags.join(",")
        }

        FakeData.post((this.props.isEdit) ? "/editGroup.php?auth0&fromChat" : "/createGroup.php?auth0&fromChat", dataTo, {
            success: ((res) => {
                if (this.props.isEdit) {
                    //console.log(res);
                    this.props.onClose(null)
                    return
                }

                this.props.onClose(res)
                FakeData.alert("Group was created!")
            }),
            error: ((err) => {

            })
        }, true, "", (d) => { })
    }

    saveAllTeamGroup = () => {
        const { group, errors, isAll, type, topic } = this.state
        const friends = FakeData.listify(FakeData.getData("yoo").friends);

        if (group.name === "" || group.name.length < 3) {
            errors.name = true;
            this.setState({ errors });
            return;
        }

        if (isAll) {
            group.teams = this.props.teams;
            errors.teams = false;
            this.setState({ errors, group });
        }

        if (this.props.isParent) {
            const list = [];
            const _tags = [];
            group.teams.forEach((team) => {
                if (!FakeData.inArray(team.id + "^T_" + team.activeSquad.id + "^S", _tags)) {
                    _tags.push(team.id + "^T_" + team.activeSquad.id + "^S");
                }
                this.getParents(team).forEach((item, i) => {
                    if (!FakeData.inArray(item.id + "^F", group.members)) {
                        list.push(item.id + "^F");
                    }
                });
            })

            group.members = list;
            errors.members = false;
            group.tags = _tags;
            this.setState({ errors, group });
        } else if (this.props.isTeam) {
            const list = [];
            const _tags = [];
            group.teams.forEach((team) => {
                if (!FakeData.inArray(team.id + "^T_" + team.activeSquad.id + "^S", _tags)) {
                    _tags.push(team.id + "^T_" + team.activeSquad.id + "^S");
                }
                team.players.forEach((item, i) => {
                    if (!FakeData.inArray(item.userId + "^F", group.members)) {
                        list.push(item.userId + "^F");
                    }
                });
            })

            group.members = list;
            errors.members = false;
            group.tags = _tags;
            this.setState({ errors, group });
        }

        if (group.members.length === 0) {
            errors.members = true;
            this.setState({ errors });
            return;
        }

        const _that = this;
        const dataTo = {
            group,
            id: (this.props.isEdit) ? this.props.data.id : 0,
            team: (this.props.isEdit) ? this.props.data.team : group.teams[0],
            userFrom: FakeData.getData("yoo").id,
            type: this.props.isTeam ? "team" : "parent",
            teamType: this.props.eventToType ? this.props.eventToType : "T",
            topic,
            tags: group.tags.join(",")
        }

        FakeData.post((this.props.isEdit) ? "/editGroup.php?auth0&fromChat" : "/createGroup.php?auth0&fromChat", dataTo, {
            success: ((res) => {
                if (this.props.isEdit) {
                    //console.log(res);
                    this.props.onClose(null)
                    return
                }

                this.props.onClose(res)
                FakeData.alert("Group was created!")
            }),
            error: ((err) => {

            })
        }, true, "", (d) => { })
    }

    getParents = (team = { players: [] }) => {
        const _p = [];
        team.players.forEach((item, i) => {
            if (item.parents) {
                FakeData.listify(item.parents).forEach((p, _i) => {
                    if (!FakeData.inArray(p, _p)) {
                        _p.push(p.user)
                    }
                })
            }
        })

        return _p;
    }

    getAllParents = (teams = []) => {
        const _p = [];
        teams.forEach((item, i) => {
            const parents = this.getParents(item);
            if (parents.length > 0) {
                parents.forEach((p, _i) => {
                    if (!FakeData.inArray(p, _p)) {
                        _p.push(p)
                    }
                })
            }
        })

        return _p;
    }

    getAllPlayers = (teams = []) => {
        const _p = [];
        teams.forEach((item, i) => {
            const parents = item.players;
            if (parents.length > 0) {
                parents.forEach((p, _i) => {
                    if (!FakeData.inArray(p, _p)) {
                        _p.push(p.user)
                    }
                })
            }
        })

        return _p;
    }

    render = () => {
        const { group, errors, isAll, filter, topic, topics, type, isAllTeams, tFilter } = this.state
        const { isCoachView, isSelective } = this.props;
        const friends = FakeData.listify(FakeData.getData("yoo").friends);
        if (isCoachView && !isSelective) {
            return (
                <Modal isOpen={this.props.isOpen} onClose={() => this.props.onClose(null)}>
                    <div className="add-place" style={{ width: "40vw", maxHeight: "80vh", overflowY: "auto" }}>
                        <h1>{(this.props.isEdit) ? "Edit " + this.props.data.name : "Add Group"}</h1>
                        <div className={(errors.name) ? "input-field error" : "input-field"}>
                            <span>Group Name</span>
                            <input value={group.name} style={{ padding: "4px" }} onChange={(e) => {
                                errors.name = e.target.value.length < 3 ? true : false;
                                group.name = e.target.value
                                this.setState({ errors, group });
                            }} />
                        </div>
                        <div className={(errors.topic) ? "input-field error" : "input-field"}>
                            <span>Group Topic</span>
                            <select value={topic} style={{ padding: "4px" }} onChange={(e) => {
                                errors.topic = false;
                                group.topic = e.target.value;
                                this.setState({ topic: e.target.value, errors, group });
                            }} ref={(node) => {
                                if (node) {
                                    node.style.setProperty("border", "1px solid #ccc", "important");
                                    node.style.setProperty("height", "30px", "important");
                                }
                            }}>
                                {
                                    topics.map((item, i) => {
                                        return (
                                            <option key={i} value={item}>{item}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        <div className={"input-field"}>
                            <span>Search Team</span>
                            <input value={tFilter} style={{ padding: "4px" }} onChange={(e) => {
                                this.setState({ tFilter: e.target.value });
                            }} />
                        </div>
                        <div className={errors.teams ? "documents-player-select error" : "documents-player-select"} style={{ marginBottom: "10px" }}>
                            <div className={isAllTeams ? "documents-player-select-item active" : "documents-player-select-item"} onClick={() => {
                                errors.teams = false;
                                if (isAllTeams) {
                                    group.teams = [];
                                    errors.teams = true;
                                }
                                this.setState({ isAllTeams: !isAllTeams, errors, group });
                            }}>All</div>
                            {!isAllTeams &&
                                FakeData.listify(this.props.teams).filter((item, i) => {
                                    return item.name.toLowerCase().indexOf(tFilter.toLowerCase()) > -1;
                                }).map((item, i) => {
                                    return (
                                        <div className={this.inArray("id", item, group.teams) ? "documents-player-select-item active" : "documents-player-select-item"} key={i} onClick={() => this.setTeams(item)}>{item.name}</div>
                                    )
                                })
                            }
                        </div>
                        <div className={(errors.type) ? "input-field error" : "input-field"}>
                            <span>Group Type</span>
                            <select value={type} style={{ padding: "4px" }} onChange={(e) => {
                                errors.type = false;
                                if (group.type !== e.target.value) {
                                    group.members = [];
                                    errors.members = true;
                                }

                                group.type = e.target.value;
                                this.setState({ type: e.target.value, errors, group });
                            }} ref={(node) => {
                                if (node) {
                                    node.style.setProperty("border", "1px solid #ccc", "important");
                                    node.style.setProperty("height", "30px", "important");
                                }
                            }}>
                                <option value={"Player"}>{"Player"}</option>
                                <option value={"Parent"}>{"Parent"}</option>
                            </select>
                        </div>
                        <div className={"input-field"}>
                            <span>Search</span>
                            <input value={filter} style={{ padding: "4px" }} onChange={(e) => {
                                this.setState({ filter: e.target.value });
                            }} />
                        </div>
                        <div className={errors.members ? "documents-player-select error" : "documents-player-select"}>
                            <div className={isAll ? "documents-player-select-item active" : "documents-player-select-item"} onClick={() => {
                                errors.members = false;
                                if (isAll) {
                                    group.users = [];
                                    errors.members = true;
                                }
                                this.setState({ isAll: !isAll, errors, group });
                            }}>All</div>
                            {!isAll && type === "Player" &&
                                this.getAllPlayers(group.teams).filter((item, i) => {
                                    return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
                                }).map((item, i) => {
                                    return (
                                        <div className={this.inMembers(item, group.users) ? "documents-player-select-item active" : "documents-player-select-item"} key={i} onClick={() => this.setPlayers(item, false)}>{item.name}</div>
                                    )
                                })
                            }
                            {!isAll && type === "Parent" &&
                                this.getAllParents(group.teams).filter((item, i) => {
                                    return FakeData.nullify(item.name).toLowerCase().indexOf(filter.toLowerCase()) > -1;
                                }).map((item, i) => {
                                    return (
                                        <div className={this.inMembers(item, group.users) ? "documents-player-select-item active" : "documents-player-select-item"} key={i} onClick={() => this.setPlayers(item, false)}>{item.name}</div>
                                    )
                                })
                            }
                        </div>
                        <button onClick={this.saveTeamgroup.bind(this)}>Create Group</button>
                    </div>
                </Modal>
            )
        }

        if (isCoachView && isSelective) {
            return (
                <Modal isOpen={this.props.isOpen} onClose={() => this.props.onClose()}>
                    <div className="add-place" style={{ width: "40vw", maxHeight: "80vh" }}>
                        <h1>{(this.props.isEdit) ? "Edit " + this.props.data.name : "Add Chat"}</h1>

                        <div className={(errors.topic) ? "input-field error" : "input-field"}>
                            <span>Choose Topic</span>
                            <select value={topic} style={{ padding: "4px" }} onChange={(e) => {
                                errors.topic = false;
                                group.name = e.target.value;
                                group.topic = e.target.value;
                                this.setState({ topic: e.target.value, errors, group });
                            }} ref={(node) => {
                                if (node) {
                                    node.style.setProperty("border", "1px solid #ccc", "important");
                                    node.style.setProperty("height", "30px", "important");
                                }

                                if (group.name === "") {
                                    group.name = "General";
                                    this.setState({ group });
                                }
                            }}>
                                {
                                    topics.map((item, i) => {
                                        return (
                                            <option key={i} value={item}>{item}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        <div className={errors.teams ? "documents-player-select error" : "documents-player-select"}>
                            <div className={isAll ? "documents-player-select-item active" : "documents-player-select-item"} onClick={() => {
                                errors.teams = false;
                                if (isAll) {
                                    group.teams = [];
                                    errors.teams = true;
                                }
                                this.setState({ isAll: !isAll, errors, group });
                            }}>All</div>
                            {!isAll &&
                                FakeData.listify(this.props.teams).filter((item, i) => {
                                    return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
                                }).map((item, i) => {
                                    return (
                                        <div className={this.inArray("id", item, group.teams) ? "documents-player-select-item active" : "documents-player-select-item"} key={i} onClick={() => this.setTeams(item)}>{item.name}</div>
                                    )
                                })
                            }
                        </div>
                        <button onClick={this.saveAllTeamGroup.bind(this)}>Create Group</button>
                    </div>
                </Modal>
            )
        }

        return (
            <Modal isOpen={this.props.isOpen} onClose={() => this.props.onClose(null)}>
                <div className="add-place" style={{ width: "40vw", maxHeight: "80vh" }}>
                    <h1>{(this.props.isEdit) ? "Edit " + this.props.data.name : "Add Group"}</h1>
                    <EField title="Group Photo" lblStyle={{ textAlign: "left", fontWeight: "normal" }}>
                        <div style={{ width: "100%", height: "150px", background: "#374353", position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <img className={errors.file ? "error" : ""} src={group.file !== null ? group.file.url : ""} style={{ height: "100%", width: "100%", objectFit: "cover", objectPosition: "center", opacity: (group.file !== null) ? 1 : 0 }} />
                            <div style={{ position: "absolute" }} className={errors.file ? "error" : ""}>
                                <i className="material-icons" style={{ color: "#FFF" }}>{(group.file !== null && group.file.progress < 95) ? "slow_motion_video" : "camera_alt"}</i>
                                <input type={"file"} accept="image/*" disabled={(group.file !== null && group.file.progress < 95) ? true : false} onChange={(e) => this.onFilesPicked(e.target.files)} style={{ position: "absolute", left: 0, top: 0, right: 0, bottom: 0, opacity: 0 }} />
                            </div>
                        </div>
                    </EField>
                    <div className={(errors.name) ? "input-field error" : "input-field"}>
                        <span>Group Name</span>
                        <input value={group.name} style={{ padding: "4px" }} onChange={(e) => {
                            errors.name = e.target.value.length < 3 ? true : false;
                            group.name = e.target.value
                            this.setState({ errors, group });
                        }} />
                    </div>
                    <div className={"input-field"}>
                        <span>Search</span>
                        <input value={filter} style={{ padding: "4px" }} onChange={(e) => {
                            this.setState({ filter: e.target.value });
                        }} />
                    </div>
                    <div className={errors.members ? "documents-player-select error" : "documents-player-select"}>
                        <div className={isAll ? "documents-player-select-item active" : "documents-player-select-item"} onClick={() => {
                            errors.members = false;
                            if (isAll) {
                                group.members = [];
                                errors.members = true;
                            }
                            this.setState({ isAll: !isAll, errors, group });
                        }}>All</div>
                        {!isAll &&
                            friends.filter((item, i) => {
                                return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
                            }).map((item, i) => {
                                return (
                                    <div className={FakeData.inArray(item.id + "^F", group.members) ? "documents-player-select-item active" : "documents-player-select-item"} key={i} onClick={() => this.setPlayers(item.id + "^F")}>{item.name}</div>
                                )
                            })
                        }
                    </div>
                    <button onClick={this.save.bind(this)}>Create Group</button>
                </div>
            </Modal>
        )
    }
}

export class CreateMessasingModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            subject: "",
            value: "",
            msg: "",
            isSelecting: false,
            filter: "",
            type: "Player",
            topic: this.props.withTopic ? this.props.topic : "General",
            topics: [
                "General",
                "Announcements",
                "Game",
                "Team Event",
                "Training",
                "Accounts",
                "Social",
                "Schedules",
                "Meeting",
                "Fundraising",
                "Clases",
                "Tournaments",
                "Camps"
            ],
            message: {
                members: this.props.withUsers ? this.props.users : [],
            },
            errors: {
                name: false,
                members: false,
                file: false,
                team: false,
                topic: false,
                type: false,
                teams: false
            },
            isAll: false
        }
    }

    onClose() {
        this.props.onClose()
    }

    setPlayers = (tag) => {
        const { message, errors, filter } = this.state
        if (!this.inArray(tag, message.members)) {
            message.members.push(tag)
            errors.members = false
            this.setState({ errors, message });
        } else {
            const _index = message.members.indexOf(tag);
            message.members.splice(_index, 1)
            errors.members = message.members.length < 1 ? true : false
            this.setState({ errors, message });
        }
    }

    onSend() {
        const to = this.state.message.members;
        if (to.length === 0) {
            alert("Please Select Recipients!")
            this.setState({
                emailError: true
            });
            return
        }

        if (this.state.subject === "") {
            this.setState({
                subjectError: true
            });

            return
        }

        if (this.state.msg === "") {
            this.setState({
                msgError: true
            });

            return
        }

        const tagList = [];
        to.forEach((item, i) => {
            tagList.push(item.id + "^F");
        })

        const _that = this;
        const dataTo = {
            user: FakeData.getData("yoo"),
            userToId: this.props.eventToID,
            userToType: this.props.eventToType,
            isGroup: true,
            users: to,
            value: (this.props.value === "") ? this.state.value : this.props.value,
            subject: this.props.isFromChat ? this.state.subject : "[" + this.state.topic + "]" + this.state.subject,
            msg: FakeData.br(this.state.msg),
            tags: tagList.join(","),
            fromChat: true
        }

        FakeData.post("/sendEventMail.php?auth0", dataTo, {
            success: ((res) => {
                _that.onClose()
            }),
            error: ((err) => {

            })
        }, true, "Email Sent!", ((d) => {

        }))
    }

    getParents = (team = { players: [] }) => {
        const _p = [];
        team.players.forEach((item, i) => {
            if (item.parents) {
                FakeData.listify(item.parents).forEach((p, _i) => {
                    if (!FakeData.inArray(p, _p)) {
                        _p.push(p.user)
                    }
                })
            }
        })

        return _p;
    }

    getAllParents = (teams = []) => {
        const _p = [];
        teams.forEach((item, i) => {
            const parents = this.getParents(item);
            if (parents.length > 0) {
                parents.forEach((p, _i) => {
                    if (!FakeData.inArray(p, _p)) {
                        _p.push(p)
                    }
                })
            }
        })

        return _p;
    }

    getAllPlayers = (teams = []) => {
        const _p = [];
        teams.forEach((item, i) => {
            const parents = item.players;
            if (parents.length > 0) {
                parents.forEach((p, _i) => {
                    if (!FakeData.inArray(p, _p)) {
                        _p.push(p.user)
                    }
                })
            }
        })

        return _p;
    }

    inArray = (item, arr = []) => {
        const _list = arr.filter((_item) => {
            return item.id === _item.id;
        })

        return _list.length > 0 ? true : false
    }

    getEmailSpread = () => {
        const { message } = this.state;
        const _list = [];
        message.members.forEach((item, i) => {
            if (item.email === "") {

            } else {
                _list.push(item.email)
            }
        })

        return _list.length === 0 ? "No Emails Found!" : _list.join(", ");
    }

    render() {
        const { } = this.state;
        const { isSelecting, message, errors, isAll, filter, topic, topics, type } = this.state
        const { isCoachView, withUsers, withTopic } = this.props;
        const friends = FakeData.listify(FakeData.getData("yoo").friends);
        const sendTo = FakeData.getData("eventMailTo");
        if (!isCoachView) {
            return (
                <Modal isOpen={this.props.isOpen} onClose={() => this.onClose()}>
                    <div className="add-place send-event-msg" style={{ width: "40vw" }}>
                        <div className="send-event-msg-header">
                            <div className="send_msg_btn" style={{ width: withTopic ? "70px" : "100px", height: withTopic ? "70px" : "100px" }} onClick={() => this.onSend()} />
                            <div className="send-event-msg-header-fields">
                                <div className="send-event-msg-header-field" onClick={() => {
                                    errors.members = true;
                                    this.setState({ errors });
                                }}>
                                    <span>To</span>
                                    <input value={this.getEmailSpread()} readOnly />
                                </div>
                                <div className="send-event-msg-header-field">
                                    <span>Subject</span>
                                    <input placeholder="Subject" className={(this.state.subjectError) ? "error" : ""} value={this.state.subject} onChange={(e) => {
                                        this.setState({
                                            subject: e.target.value,
                                            subjectError: false
                                        });
                                    }} />
                                </div>
                                {!withTopic &&
                                    <div className="send-event-msg-header-field">
                                        <span>Topic</span>
                                        <select placeholder="Subject" className={(errors.topic) ? "error" : ""} value={this.state.topic} onChange={(e) => {
                                            errors.topic = false;
                                            this.setState({
                                                topic: e.target.value,
                                                errors
                                            });
                                        }} style={{ flex: 2, border: "1px solid #ccc" }}>
                                            {
                                                topics.map((item, i) => {
                                                    return (
                                                        <option key={i} value={item}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                }
                            </div>
                        </div>

                        <div className={"input-field"} style={{ marginTop: "10px" }}>
                            <span>Search</span>
                            <input value={filter} style={{ padding: "4px" }} onChange={(e) => {
                                this.setState({ filter: e.target.value });
                            }} />
                        </div>

                        <div className={errors.members ? "documents-player-select error" : "documents-player-select"}>
                            <div className={isAll ? "documents-player-select-item active" : "documents-player-select-item"} onClick={() => {
                                errors.members = false;
                                if (isAll) {
                                    message.members = [];
                                    errors.members = true;
                                } else {
                                    message.members = friends;
                                    errors.members = false;
                                }
                                this.setState({ isAll: !isAll, errors, message });
                            }}>All</div>
                            {!isAll &&
                                friends.filter((item, i) => {
                                    return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
                                }).map((item, i) => {
                                    return (
                                        <div className={FakeData.inArray(item, message.members) ? "documents-player-select-item active" : "documents-player-select-item"} key={i} onClick={() => this.setPlayers(item)}>{item.name}</div>
                                    )
                                })
                            }
                        </div>
                        <textarea value={this.state.msg} className={(this.state.msgError) ? "error" : ""} placeholder="Message" onChange={(e) => {
                            this.setState({
                                msg: e.target.value,
                                msgError: false
                            });
                        }} style={{ resize: "vertical" }} />
                    </div>
                </Modal>
            );
        }

        return (
            <Modal isOpen={this.props.isOpen} onClose={() => this.onClose()}>
                <div className="add-place send-event-msg" style={{ width: "40vw" }}>
                    <div className="send-event-msg-header">
                        <div className="send_msg_btn" style={{ width: withTopic ? "70px" : "100px", height: withTopic ? "70px" : "100px" }} onClick={() => this.onSend()} />
                        <div className="send-event-msg-header-fields">
                            <div className="send-event-msg-header-field" onClick={() => {
                                errors.members = message.members.length === 0 ? true : false;
                                this.setState({ errors });
                            }}>
                                <span>To</span>
                                <input value={this.getEmailSpread()} readOnly />
                            </div>
                            <div className="send-event-msg-header-field">
                                <span>Subject</span>
                                <input placeholder="Subject" className={(this.state.subjectError) ? "error" : ""} value={this.state.subject} onChange={(e) => {
                                    this.setState({
                                        subject: e.target.value,
                                        subjectError: false
                                    });
                                }} />
                            </div>
                            {!withTopic &&
                                <div className="send-event-msg-header-field">
                                    <span>Topic</span>
                                    <select placeholder="Subject" className={(errors.topic) ? "error" : ""} value={this.state.topic} onChange={(e) => {
                                        errors.topic = false;
                                        this.setState({
                                            topic: e.target.value,
                                            errors
                                        });
                                    }} style={{ flex: 2, border: "1px solid #ccc" }}>
                                        {
                                            topics.map((item, i) => {
                                                return (
                                                    <option key={i} value={item}>{item}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            }
                        </div>
                    </div>
                    {!withUsers &&
                        <div className={(errors.type) ? "input-field error" : "input-field"} style={{ marginTop: "10px" }}>
                            <span>Send To Player/Parent?</span>
                            <select value={type} style={{ padding: "4px" }} onChange={(e) => {
                                errors.type = false;
                                message.type = e.target.value;
                                message.members = [];
                                errors.members = true;
                                this.setState({ type: e.target.value, errors, message });
                            }} ref={(node) => {
                                if (node) {
                                    node.style.setProperty("border", "1px solid #ccc", "important");
                                    node.style.setProperty("height", "30px", "important");
                                }
                            }}>
                                <option value={"Player"}>{"Player"}</option>
                                <option value={"Parent"}>{"Parent"}</option>
                            </select>
                        </div>
                    }
                    {!withUsers &&
                        <div className={"input-field"}>
                            <span>Search</span>
                            <input value={filter} style={{ padding: "4px" }} onChange={(e) => {
                                this.setState({ filter: e.target.value });
                            }} />
                        </div>
                    }

                    {!withUsers &&
                        <div className={errors.members ? "documents-player-select error" : "documents-player-select"}>
                            <div className={isAll ? "documents-player-select-item active" : "documents-player-select-item"} onClick={() => {
                                errors.members = false;
                                if (isAll) {
                                    message.members = [];
                                    errors.members = true;
                                } else {
                                    message.members = type === "Player" ? this.getAllPlayers(this.props.teams) : this.getAllParents(this.props.teams);
                                    errors.members = false;
                                }
                                this.setState({ isAll: !isAll, errors, message });
                            }}>All</div>
                            {!isAll && type === "Player" &&
                                this.getAllPlayers(this.props.teams).filter((item, i) => {
                                    return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
                                }).map((item, i) => {
                                    return (
                                        <div className={this.inArray(item, message.members) ? "documents-player-select-item active" : "documents-player-select-item"} key={i} onClick={() => this.setPlayers(item)}>{item.name}</div>
                                    )
                                })
                            }
                            {!isAll && type === "Parent" &&
                                this.getAllParents(this.props.teams).filter((item, i) => {
                                    return FakeData.nullify(item.name).toLowerCase().indexOf(filter.toLowerCase()) > -1;
                                }).map((item, i) => {
                                    return (
                                        <div className={this.inArray(item, message.members) ? "documents-player-select-item active" : "documents-player-select-item"} key={i} onClick={() => this.setPlayers(item)}>{item.name}</div>
                                    )
                                })
                            }
                        </div>
                    }
                    <textarea value={this.state.msg} className={(this.state.msgError) ? "error" : ""} placeholder="Message" onChange={(e) => {
                        this.setState({
                            msg: e.target.value,
                            msgError: false
                        });
                    }} style={{ resize: "vertical" }} />
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/Chat.js